import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import { Parallax } from 'react-scroll-parallax';

import Layout from '../ui/Layout';
import Loading from '../ui/Loading';
import fetchDux from '../../state/fetch-dux';

const PREVIEW_LIMIT = 300;

const getPreviewText = text => {
  if (!text) return '';
  if (text.length < PREVIEW_LIMIT) return text;

  const limit = text.slice(0, PREVIEW_LIMIT);

  return limit.slice(0, limit.lastIndexOf(' ')) + ' ...';
};

const sortContent = (a, b) => {
  const displayOrderA = ((a || {}).assetParent || {}).displayOrder;
  const displayOrderB = ((b || {}).assetParent || {}).displayOrder;

  return displayOrderA - displayOrderB;
}

class KnowledgeCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null
    };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.getKnowledgeCenterArticles();
  }
  componentWillUnmount() {
    this.props.clearGetContent();
  }
  render() {
    const { page, articles, error, inProgress } = this.props;
    const content = this.state.content || articles || [];

    const handleSearch = e => {
      const re = new RegExp(e.target.value, 'i');
      const content = (articles || []).filter(c => {
        const { data, tags } = c;
        return re.test(data.title) ||
          re.test(data.author) ||
          (data.sections || []).find(s => re.test(s.textSection)) ||
          (tags || []).find(t => re.test(t.value));
      });
      this.setState({ content });
    };

    const formattedContent = (content || []).sort(sortContent)
      .reduce((prev, next, idx) => {
        const index = Math.floor(idx / 3)
        const nextPrev = Object.assign([], prev);
        nextPrev[index] = nextPrev[index] || [];
        nextPrev[index].push(next);
        return nextPrev;
      }, []);

    return (
      <Layout route="knowledge-center" knowledgeCenter>
        {inProgress && <Loading />}
        {!inProgress &&
          <main>

            <section className="box-banner">
              <Parallax
                offsetXMax={10}
                offsetXMin={-10}
                className="chem"
                slowerScrollRate
              />
              <Grid>
                <Row>
                  <Col sm={12}>
                    <Parallax offsetYMax={15} offsetYMin={-12} slowerScrollRate>
                      <div className="brand" />
                    </Parallax>
                    <Parallax offsetYMax={15} offsetYMin={-15}>
                      <p>
                        Over the years WineXRay has maintained a strong educational
                        relationship with the University of California, Davis. This
                        partnership awakened the true spirit of WineXRay, to be
                        ambassadors of phenolics. So we have created a centralized
                        location for you to explore the power of phenolics.
                      </p>
                    </Parallax>
                  </Col>
                </Row>
              </Grid>
            </section>

            <section className="box-articles">
              <Grid>
                <Row>
                  <Col sm={12}>

                    <div className="search">
                      <input
                        name="search"
                        type="text"
                        placeholder="Search"
                        onChange={handleSearch}
                      />
                    </div>

                    {/*
                    <h2>
                      <span>All about Winemaking</span>
                      <div className="view-all">View all</div>
                    </h2>
                    */}

                    <Row>
                      {formattedContent.map(f => (
                        <Row>
                          {(f || []).map((r, index) => {
                            const {
                              data,
                              assetParent,
                              tags
                            } = r || {};
                            const previewSection = (data.sections || [])
                              .find(s => s.__type__ === 'textSection') || {};
                            const previewText = getPreviewText(
                              previewSection.textSection
                            );
                            const imgUrl = (data.headerImage || {}).href;
                            return (
                              <Col sm={4} key={index}>
                                <Link
                                  to={`/knowledge-center/article/${data.slug}`}
                                  className="article"
                                >
                                  <div className="cover">
                                    <div
                                      className="image"
                                      style={{ backgroundImage: `url(${imgUrl})` }}
                                    />
                                    <div className="published">
                                      <span>
                                        Published:
                                        {' '}
                                        {moment(assetParent.publishedDate).format(
                                          'MM/DD/YYYY'
                                        )}
                                      </span>
                                      <strong>Article</strong>
                                    </div>
                                  </div>
                                  <h3>{data.title}</h3>
                                  <div className="source">{data.author}</div>
                                  <p dangerouslySetInnerHTML={{ __html: previewText }}>
                                  </p>
                                  {(tags || [])
                                    .map((tag, i) => (
                                      <div key={i} className="tag">{tag.value}</div>
                                    ))}
                                </Link>
                              </Col>
                            );
                          })}
                        </Row>
                      ))}
                    </Row>
                    
                    {/*
                    <h2>
                      <span>All about Phenolics</span>
                      <div className="view-all">View all</div>
                    </h2>
                    */}
                    
                  </Col>
                </Row>
              </Grid>
            </section>

          </main>}
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    inProgress: getContentInProgress,
    error: getContentError,
    result: page
  } = state.getContent.toJS();
  const {
    inProgress: getKnowledgeCenterArticlesInProgress,
    error: getKnowledgeCenterArticlesError,
    result: articles
  } = state.getKnowledgeCenterArticles.toJS();

  const inProgress = getKnowledgeCenterArticlesInProgress ||
    getContentInProgress;
  const error = getKnowledgeCenterArticlesError || getContentError;

  return {
    page,
    articles,
    inProgress,
    error
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction,
      getKnowledgeCenterArticles: fetchDux.getKnowledgeCenterArticles.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(KnowledgeCenter);



// WEBPACK FOOTER //
// ./src/components/routes/KnowledgeCenter.js